import { actionTypes } from "./login.actions";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO:
        case actionTypes.LOGIN_REQUEST:
            return {
                ...state,
                isLoading: true,
                isLoginOpen: true
            };
        case actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS:
        case actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_ERROR:
        case actionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isIncorrectCredentials: null
            };
        case actionTypes.LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                isIncorrectCredentials: action.isIncorrectCredentials
            };
        case actionTypes.LOGIN_CLEAR_ERROR:
            return {
                ...state,
                isError: false,
                isLoading: false,
                isIncorrectCredentials: null,
                isLoginOpen: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/common/loginPage/login.reducer.js